import React, {useEffect, useState} from 'react'
import {Form, Formik} from "formik";
import {InputField} from "../../InputField";
import FormGroup from "../../FormGroup";
import GenericOffCanvas from "../../../UI/Canvas/GenericOffCanvas";
import GenericCanvasActions from "../../../UI/Canvas/GenericCanvasActions";
import curvatureService from "../../../../../services/curvatureService";
import {curvatureForm} from "./curvatureForm";
import {toast} from "react-toastify";

const ColorOffCanvas = ({isOpen, toggle, data, handleResponse}) => {

    const [initialValues, setInitialValues] = useState(curvatureForm.initialValues)
    const handleSubmit = (values) => data ? curvatureService.update(data.uuid, values) : curvatureService.store(values);

    useEffect(() => {
        data ? setInitialValues({
            name: data.name || '',
            description: data.description || '',
            note: data.note || '',
        }) : setInitialValues(curvatureForm.initialValues)
    }, [data]);

    return <GenericOffCanvas
        title={data ? 'Modifica ' + data.name : 'Crea curvatura'}
        isOpen={isOpen}
        toggle={toggle}>
        <Formik initialValues={initialValues}
                validationSchema={curvatureForm.validation}
                enableReinitialize={true}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values)
                        .then(res => {
                            toast.success('Operazione eseguita con successo')
                            handleResponse(res)
                            toggle(false)
                        })
                        .catch(err => toast.error(err.response.data.message))
                        .finally(() => setSubmitting(false))
                }}>
            {() => (
                <Form>
                    <FormGroup name="name" label="Nome" required={true} inline={false}>
                        <InputField name="name" type="text" maxLength={100}/>
                    </FormGroup>
                    <FormGroup name="description" label="Descrizione" required={false} inline={false}>
                        <InputField name="description" type="text"/>
                    </FormGroup>
                    <FormGroup name="note" label="Note" required={false} inline={false}>
                        <InputField name="note" component="textarea" rows={6}/>
                    </FormGroup>
                    <GenericCanvasActions toggle={toggle}/>
                </Form>
            )}
        </Formik>
    </GenericOffCanvas>

}

export default ColorOffCanvas